import { render, staticRenderFns } from "./wechatLabelItem.vue?vue&type=template&id=a14e1de2&scoped=true"
import script from "./wechatLabelItem.vue?vue&type=script&lang=js"
export * from "./wechatLabelItem.vue?vue&type=script&lang=js"
import style0 from "./wechatLabelItem.vue?vue&type=style&index=0&id=a14e1de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14e1de2",
  null
  
)

export default component.exports